import { createNavigationContainerRef } from "@react-navigation/native";
import { RootStackParamList } from "../../app/navigator";

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

export function navigateToJoinTournaments(
  tournamentId: string,
  entryLevel?: number
) {
  if (!navigationRef.isReady()) return;

  navigationRef.navigate("JoinTournaments", {
    tournamentId,
    entryLevel,
  });
}
